<template>
  <v-autocomplete
    outlined
    hide-details="auto"
    dense
    single-line
    :items="list"
    v-model="_value"
    no-data-text=""
    ref="select"
    v-bind="$attrs"
    :search-input.sync="search"
    v-on="$listeners"
    :rules="_rules"
    :readonly="readonly"
    :label="_label"
    :placeholder="_placeholder"
  >
    <template v-slot:prepend-item v-if="useDirect === true || useDirect == 'Y'">
      <v-list-item ripple @click="directInput.show = true">
        <v-list-item-action>
          <i-btn icon x-small>
            <i class="material-icons-outlined icon-type-02">edit</i>
          </i-btn>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>
            {{ $t('직접입력') }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <BasePopup
        width="300px"
        v-model="directInput.show"
        :confrimButtonDisabled="!directInput.text"
        @confirm="onDirect"
      >
        <div class="pt-5">
          <i-text-field
            v-if="directInput.show"
            autofocus
            hide-details
            filled
            dense
            rounded
            v-model="directInput.text"
            @keydown.enter="
              () => {
                directInput.text && onDirect(true);
              }
            "
            ref="text"
          />
        </div>
      </BasePopup>
    </template>
  </v-autocomplete>
</template>

<script>
import { deduplicate, isFunction, isString } from '@/utils/util';
export default {
  name: 'DirectInputSelect',

  props: {
    items: {
      type: Array, //직접입력을 위한 셀렉트기때문에  string 배열만
      default: () => [],
    },
    value: {
      type: String,
    },
    useDirect: {
      type: [Boolean, String],
      default: false,
    },
    rules: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  mounted() {
    this.form?.register?.(this.$refs.select);
  },
  data() {
    return {
      directInput: {
        show: false,
        text: '',
      },
      search: '',
    };
  },
  inject: {
    form: {
      default: null,
    },
  },
  watch: {
    'directInput.show'(isOpen) {
      if (isOpen) {
        this.directInput.text = '';
      }
    },
  },
  computed: {
    _label() {
      return this.$t(this.label);
    },
    _placeholder() {
      return this.$t(this.placeholder);
    },
    _rules() {
      return (
        this.rules?.map(validate => {
          return !isFunction(validate)
            ? validate
            : () => {
                const result = validate(this.value);
                return isString(result) ? this.$t(result) : result;
              };
        }) || []
      );
    },
    readonly() {
      if (this.$attrs.hasOwnProperty('readonly')) return this.$attrs.readonly;
      else if (this.form) return this.form.readonly;
      else return false;
    },
    _value: {
      get() {
        return String(this.value);
      },
      set(v) {
        this.$emit('input', v);
        this.$nextTick(() => {
          this.$emit('change', String(v));
        });
      },
    },
    list() {
      return deduplicate([...(this.items ?? []), this.value]).filter(v => v);
    },
  },
  methods: {
    onDirect(confirm) {
      if (!confirm) return;
      this._value = this.directInput.text;
      this.$refs.select.blur();
    },
  },
};
</script>

<style></style>
